import React from 'react';

interface DepositScreenProps {
  paymentMethods: any[];
  paymentsLoading: boolean;
  selectedPayment: any;
  setSelectedPayment: (method: any) => void;
  uploadingImage: boolean;
  onCopyToClipboard: (text: string) => void;
  onUploadReceipt: () => void;
  onOpenPaymentPortal: (url: string) => void;
}

export const DepositScreen: React.FC<DepositScreenProps> = ({
  paymentMethods,
  paymentsLoading,
  selectedPayment,
  setSelectedPayment,
  uploadingImage,
  onCopyToClipboard,
  onUploadReceipt,
  onOpenPaymentPortal,
}) => {
  const getAssetUrl = (path?: string) => {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    return path;
  };

  if (selectedPayment) {
    return (
      <div className="pwa-tab-scroll">
        <button
          onClick={() => setSelectedPayment(null)}
          style={{ background: 'none', border: 'none', color: '#8B5CF6', fontSize: '13px', fontWeight: '700', cursor: 'pointer', marginBottom: '16px' }}
        >
          ← Back to Payment Methods
        </button>

        <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '18px', padding: '20px', marginBottom: '40px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '900', color: '#fff', marginBottom: '20px' }}>{selectedPayment.name}</h2>

          <div style={{ fontSize: '10px', fontWeight: '900', letterSpacing: '1px', color: 'rgba(255,255,255,0.4)', marginBottom: '6px', textTransform: 'uppercase' }}>
            ACCOUNT / WALLET ADDRESS
          </div>

          <div style={{ display: 'flex', alignItems: 'center', background: 'rgba(255,255,255,0.05)', borderRadius: '12px', padding: '6px 6px 6px 14px', marginBottom: '20px' }}>
            <div style={{ flex: 1, fontSize: '13px', color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {selectedPayment.account_information}
            </div>
            <button
              onClick={() => onCopyToClipboard(selectedPayment.account_information)}
              style={{ background: '#8B5CF6', color: '#fff', border: 'none', borderRadius: '8px', padding: '8px 12px', fontSize: '11px', fontWeight: '800', cursor: 'pointer' }}
            >
              COPY
            </button>
          </div>

          {selectedPayment.qr_code && (
            <div style={{ background: '#fff', padding: '10px', borderRadius: '12px', width: '160px', height: '160px', margin: '0 auto 20px auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img
                src={getAssetUrl(selectedPayment.qr_code)}
                alt="QR Code"
                style={{ width: '140px', height: '140px', objectFit: 'contain' }}
              />
            </div>
          )}

          <div style={{ fontSize: '10px', fontWeight: '900', letterSpacing: '1px', color: 'rgba(255,255,255,0.4)', marginBottom: '6px', textTransform: 'uppercase' }}>
            TRANSFER INSTRUCTIONS
          </div>
          <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)', lineHeight: '1.5', marginBottom: '20px' }}>
            {selectedPayment.instructions}
          </p>

          {selectedPayment.link && (
            <button
              onClick={() => onOpenPaymentPortal(selectedPayment.link)}
              style={{ width: '100%', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '12px', padding: '12px', color: '#fff', fontSize: '13px', fontWeight: '700', cursor: 'pointer', marginBottom: '20px' }}
            >
              Open Payment Portal
            </button>
          )}

          <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: '20px' }}>
            <div style={{ fontSize: '10px', fontWeight: '900', letterSpacing: '1px', color: 'rgba(255,255,255,0.4)', marginBottom: '6px', textTransform: 'uppercase' }}>
              SUBMIT COMPLETED RECEIPT
            </div>
            <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.4)', lineHeight: '1.4', marginBottom: '12px' }}>
              Share transaction receipt directly to support conversation for instant processing.
            </p>
            <button
              onClick={onUploadReceipt}
              disabled={uploadingImage}
              style={{ width: '100%', background: '#10b981', color: '#fff', border: 'none', borderRadius: '12px', padding: '14px', fontSize: '13px', fontWeight: '800', cursor: 'pointer' }}
            >
              {uploadingImage ? 'Uploading Receipt...' : 'Upload & Share Receipt'}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pwa-tab-scroll">
      <h1 className="pwa-tab-title">MANUAL DEPOSITS</h1>
      <p className="pwa-tab-subtitle">Select transfer provider and upload confirmation screenshot</p>

      {paymentsLoading ? (
        <div style={{ textAlign: 'center', padding: '30px', color: '#8B5CF6' }}>Loading payment methods...</div>
      ) : (
        paymentMethods
          .filter((p) => p.status === 'active')
          .map((method) => (
            <div
              key={method.id}
              onClick={() => setSelectedPayment(method)}
              className="pwa-payment-card"
            >
              <div>
                <div className="pwa-payment-name">{method.name}</div>
                <div className="pwa-payment-label">{method.account_information}</div>
              </div>
              <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: '18px', fontWeight: '700' }}>→</div>
            </div>
          ))
      )}
    </div>
  );
};
